import { useEffect} from "react";
import {useLocation, useNavigate, useParams} from "react-router-dom";

const SharedLinkRedirect = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const { token } = useParams();

  useEffect(() => {
  if (!token) {
    navigate('/planejadora');
    return;
  }

    sessionStorage.setItem('pendingSharedToken', token);
    sessionStorage.setItem('pendingSharedPath', location.pathname);
    navigate("/planejadora");
  }, [token, navigate, location.pathname]);

    return null;
}

export default SharedLinkRedirect;
